// Record visibility options — applies to all record types.
export const visibilities = [
  {
    value: "private",
    label: "Private",
    icon: "user",
    description: "Only you can see and edit this record",
  },
  {
    value: "shared",
    label: "Shared",
    icon: "user-friends",
    description: "Visible to all Heavybit team members",
  },
  {
    value: "public",
    label: "Public",
    icon: "users",
    description: "Visible to everyone with a link",
  },
]
